export class UrlUtils {
    static base64urlUnpadded_encode = (str: string) => {
        var utf8str = unescape(encodeURIComponent(str));
        var b64u = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'; // base64url dictionary

        /* base64_encode_data_unpadded
         * Internal helper to encode data to base64 using specified dictionary.
         */
        const base64_encode_data_unpadded = (data: string, len: number, b64x: string) => {
            var dst = 'u!';
            var i;

            for (i = 0; i <= len - 3; i += 3) {
                dst += b64x.charAt(data.charCodeAt(i) >>> 2);
                dst += b64x.charAt(
                    ((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4)
                );
                dst += b64x.charAt(
                    ((data.charCodeAt(i + 1) & 15) << 2) | (data.charCodeAt(i + 2) >>> 6)
                );
                dst += b64x.charAt(data.charCodeAt(i + 2) & 63);
            }

            if (len % 3 == 2) {
                dst += b64x.charAt(data.charCodeAt(i) >>> 2);
                dst += b64x.charAt(
                    ((data.charCodeAt(i) & 3) << 4) | (data.charCodeAt(i + 1) >>> 4)
                );
                dst += b64x.charAt((data.charCodeAt(i + 1) & 15) << 2);
            } else if (len % 3 == 1) {
                dst += b64x.charAt(data.charCodeAt(i) >>> 2);
                dst += b64x.charAt((data.charCodeAt(i) & 3) << 4);
            }

            return dst;
        };
        return base64_encode_data_unpadded(utf8str, utf8str.length, b64u);
    };
}
